/* eslint-disable jsx-a11y/anchor-is-valid */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { useMsal } from "@azure/msal-react";
import { UserPartial } from "../models/user.model";
import { USER_AUTH_TYPE } from "../enums/user-auth-type.enum";
import { useCallback, useEffect, useState } from "react";
import useTokenClaims from "../hooks/useTokenClaims";

library.add(faCaretDown);

export default function Navbar() {
  const { getTokenWithClaims } = useTokenClaims();
  const [claims, setClaims] = useState<UserPartial | null>(null);
  const location = useLocation();
  const { accounts } = useMsal();

  const handleGetClaims = useCallback(async () => {
    try {
      if (location.pathname === "/invite") {
        const tokenData = await getTokenWithClaims();
        const claims = tokenData?.idTokenClaims as UserPartial;
        setClaims(claims);
      } else if (location.pathname === "/duplicate-email-maintenance" && accounts.length > 0) {
        // This route is authenticated by EmployeeAuthenticatedRoute. Reading
        // the active account here avoids triggering a second auth redirect.
        setClaims(accounts[0].idTokenClaims as UserPartial);
      } else if (accounts.length > 0) {
        const claims = accounts[0].idTokenClaims as UserPartial;
        setClaims(claims);
      }
    } catch (error) {
      console.error("Failed to get token claims:", error);
    }
  }, [accounts, getTokenWithClaims, location.pathname]);

  useEffect(() => {
    if (!claims) {
      handleGetClaims();
    }
  }, [claims, handleGetClaims]);

  return (
    <>
      {claims ? (
        <nav className="bg-[#0042c3]">
          <div className="flex justify-between">
            <div className="pl-[30px] flex gap-4 items-center">
              <img
                className="w-12 h-12"
                src="/images/W_Essilor_Logo.svg"
                alt="Essilor Logo"
              />
              <span className="font-semibold text-xl text-white">
                {claims?.acr === USER_AUTH_TYPE.COMARCH_EMPLOYEE
                  ? location.pathname === "/duplicate-email-maintenance"
                    ? "Duplicate Email Maintenance"
                    : "Invite Portal"
                  : "Registration Portal"}
              </span>
            </div>
            <div className="flex justify-end p-4">
              <div className="flex flex-row gap-10 items-center">
                <div className="flex-col gap-4 text-white">
                  <p>{`${claims.firstName} ${claims.lastName}`}</p>
                  <p>{claims.email}</p>
                </div>
                {/* <div>
                <a onClick={(e) => logout(e)} href="#">Logout</a>
              </div> */}
              </div>
            </div>
          </div>
        </nav>
      ) : (
        <nav className="bg-[#0042c3]">
          <div className="p-4 flex items-center justify-between">
            <div className="flex">
              <img
                className="w-12 h-12"
                src="/images/W_Essilor_Logo.svg"
                alt="Essilor Logo"
              />
            </div>
          </div>
        </nav>
      )}
    </>
  );
}
